import createModel, { prop } from './lib/create_model';
import { CustomAttributeValue } from 'models/custom_attribute';

// TaskCustomAttributeChange is a customer-timeline conversation item recording a
// custom-attribute value change on a task (backend content type
// TASK_CUSTOM_ATTRIBUTE_CHANGE). Mirrors ConversationCustomAttributeChange with
// an added taskId so the change can be attributed to a specific task.
const TaskCustomAttributeChange = createModel({
  modelName: 'TaskCustomAttributeChange',

  properties: {
    taskId: prop(String).default(''),
    added: prop([CustomAttributeValue]).default([]),
    removed: prop([CustomAttributeValue]).default([]),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default TaskCustomAttributeChange;
